export default __webpack_public_path__ + "static/banner-f806ac992096c347ca9dec1de1b0e906.png";